import { put } from '../..';
import asNumber from '../../../components/AsNumber';

type EditSpacePayload = {
  LocationId: string,
  Space: {
    Name: string,
    Top: number,
    Left: number,
    Right: number,
    Bottom: number,
    Priority: boolean,
    Points,
    Polygon,
    ParentId: string,
    LocationSubtype?: string | null,
    LocationCapacity?: number,
    ExternalId?: string,
  }
}

const editSpace = ({
  LocationId,
  Space: {
    Name, Top, Left, Right, Bottom, Priority, Points, Polygon, LocationSubtype, LocationCapacity,
    ExternalId, ParentId,
  },
}: EditSpacePayload) => {
  const body: EditSpacePayload = {
    Space: {
      Name,
      Top,
      Left,
      Right,
      Bottom,
      Points: Points.map((point: { x: number, y: number, number: number }) => ({
        X: point.x, Y: point.y, Number: point.number,
      })),
      Polygon,
      Priority,
      ParentId,
    },
    LocationId,
  };

  if (LocationSubtype?.length > 0 && typeof LocationSubtype === 'string') {
    body.Space.LocationSubtype = LocationSubtype;
  }

  if (ExternalId?.length > 0 && typeof ExternalId === 'string') body.Space.ExternalId = ExternalId;

  if (asNumber(LocationCapacity)) {
    body.Space.LocationCapacity = asNumber(LocationCapacity);
  }

  return put('locations/space', body);
};

export default editSpace;
